/**
 * KAN-960: "Следующий контакт" клиента: POST /api/v1/clients/{id}/next-contact/.
 * Записывает звонок или личную встречу (новый контакт заменяет старый) и берёт
 * клиента в работу тем же путём, что "Взять в работу". DELETE убирает контакт.
 */
import { apiClient } from './client';
import type { ManagerBrief } from '@/types/manager';
import type { NextContactType } from '@/lib/nextContact';

export interface NextContactBody {
  step_type: NextContactType;
  /** ISO 8601, не в прошлом. */
  at: string;
  note?: string;
  /** Как у "Взять в работу": менеджер клиента (null: без менеджера); нет ключа - не меняется. */
  manager_id?: string | null;
}

export interface NextContactResult {
  client_id: string;
  followup_at: string;
  followup_type: NextContactType;
  followup_label: string;
  followup_note: string;
  attention_done_at: string;
  manager: ManagerBrief | null;
}

async function set(clientId: string, body: NextContactBody): Promise<NextContactResult> {
  const { data } = await apiClient.post<NextContactResult>(`/api/v1/clients/${clientId}/next-contact/`, body);
  return data;
}

/** Убрать контакт с карточки (клиент в работу не берётся). */
async function clear(clientId: string): Promise<void> {
  await apiClient.delete(`/api/v1/clients/${clientId}/next-contact/`);
}

export const nextContactApi = { set, clear };
